<template>
	<div class="tab">
		<img :src="'static/image/' + myimg + '.jpg'" width="100%"/>
		<span :style="{color: activecolor}" class="word-title">{{Suppliers[0]}}</span>
		<span :style="{color: activecolor}" class="word-title1">{{Suppliers[1]}}</span>
	</div>
</template>

<script type="text/ecmascript-6">
	export default {
		props: {
			myimg: {
				type: String,
				default: ''
			},
			activecolor: {
				type: String,
				default: 'white'
			}
		},
		computed: {
			Suppliers() {
				return this.$t('Suppliers')
			}
		}
	}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"
	@import "~common/stylus/minxin"

	.tab
		width: 100%
		font-size: 0
		position: relative
		.word-title
			position: absolute
			top: 40%
			left: 10%
			color: white
			font-size: $font-size-large-x
			@media screen and (max-width:550px)
				top: 40%
				font-size: $font-size-small-s
		.word-title1
			position: absolute
			top: 50%
			left: 10%
			color: white
			font-size: $font-size-large-x
			@media screen and (max-width:550px)
				top: 50%
				font-size: $font-size-small-s
</style>


// WEBPACK FOOTER //
// src/components/top-image/top-image.vue